import React, { useState, useMemo } from "react";

import { ActionsMenu, MenuItem } from "ui/actions-menu";

import Icons from "assets";

interface ActionsMenuProps {
  item: {
    itemName: string;
    itemId: string;
  };
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

const SmsSimulatorRulesTableActionsMenu: React.FC<ActionsMenuProps> = ({
  item,
  onEdit,
  onDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuOpen = () => setIsOpen(true);
  const handleMenuClose = () => setIsOpen(false);

  const actionItems = useMemo(
    () => [
      {
        icon: <Icons.Edit />,
        label: "Edit",
        onClick: (id: string) => onEdit(id),
      },
      {
        icon: <Icons.Trash />,
        label: "Delete",
        onClick: (id: string) => onDelete(id),
      },
    ],
    [onEdit, onDelete],
  );

  return (
    <ActionsMenu itemName={item.itemName} open={isOpen} onOpen={handleMenuOpen} onClose={handleMenuClose}>
      {actionItems.map((actionItem) => (
        <MenuItem
          key={actionItem.label}
          icon={actionItem.icon}
          label={actionItem.label}
          onClick={() => {
            if (item.itemId) {
              actionItem.onClick(item.itemId);
            }
            setIsOpen(false);
          }}
        />
      ))}
    </ActionsMenu>
  );
};

export default SmsSimulatorRulesTableActionsMenu;
